import { createRootRoute, Navigate, Outlet, useLocation } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { MainLayout } from '@/shared/ui/layout/main-layout';
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect } from 'react';
import { showToast } from '@/shared/utils/toast';
import { useIsFetching } from '@tanstack/react-query';
import { useLoadingStore } from '@/shared/lib/store/model/loading.store';
import { useCommonStore } from '@/shared/lib/store';
import { useRouter } from '@tanstack/react-router';

// eslint-disable-next-line react-refresh/only-export-components
const RootComponent = () => {
    const router = useRouter();
    const location = useLocation();
    const isMain = location.pathname === '/';
    const isDev = import.meta.env.DEV;
    const isFetching = useIsFetching();
    const { showLoading, hideLoading } = useLoadingStore();

    const currentPath = useCommonStore((s) => s.currentPath);
    const setPaths = useCommonStore.getState().setPaths;

    useEffect(() => {
        const unsub = router.subscribe('onBeforeNavigate', ({ fromLocation, toLocation }) => {
            // 내비가 막 시작될 때, 이전(from)·다음(to) 경로를 즉시 저장
            setPaths(fromLocation?.pathname ?? '', toLocation.pathname);
        });
        return () => unsub();
    }, [router, setPaths]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        isFetching ? showLoading() : hideLoading();
    }, [isFetching]);

    useEffect(() => {
        // 우클릭 disable 처리
        const naviContainer = document.getElementById('root');
        const handleContextMenu = (e: MouseEvent) => {
            console.log('handleContextMenu ignore ContextMenu');

            showToast('콘텐츠 보호를 위해 복사기능이 제한됩니다.', 3000, 'error');
            e.preventDefault();
        };
        naviContainer?.addEventListener('contextmenu', handleContextMenu);

        return () => {
            naviContainer?.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    return (
        <>
            <MainLayout>
                {isMain ? <Navigate to="/create" replace /> : <Outlet />}
            </MainLayout>
            {isDev && <TanStackRouterDevtools />}
        </>
    );
};

export const Route = createRootRoute({
    component: RootComponent,
});
